import { sizes } from '@lmc/common/constants'
import { HeaderSection, LabelIcon, theme } from '@lmc/ui-kit'
import { ProTag } from 'components/ProTag'
import { useTranslation } from 'react-i18next'
import { history } from '../../../store'
import CQITabs from './CQITabs'

export type CQIReportProps = {}

export function CQIReportComponent(): React.ReactElement {
  const { t } = useTranslation()

  const translate = (key: string, variable?: any) =>
    t(`reports.cqi.${key}`, variable)

  return (
    <div style={styles.wrapper}>
      <HeaderSection
        onClick={history.back}
        title={
          <div style={styles.flex}>
            {translate(`title`)}
            <ProTag />
          </div>
        }
      />
      <div style={styles.tabContainer}>
        <CQITabs />
      </div>
      <LabelIcon
        iconColor={theme.color.status.primary}
        iconName="QuestionCircleOutlined"
        onPress={() =>
          window.open(
            'https://support.logmycare.co.uk/en/articles/6014947-about-the-care-quality-indicators-report',
            '_blank'
          )
        }
        style={styles.helpLink}
        text="Help"
        textColor={theme.color.status.primary}
      />
    </div>
  )
}

const styles = {
  helpLink: {
    marginTop: 32
  },
  outputCell: {
    color: theme.color.status.primary,
    fontSize: 18,
    fontWeight: 700
  },
  skeleton: {
    marginTop: 16,
    minHeight: '60vh',
    opacity: 0.6
  },
  tabContainer: {
    minHeight: 440
  },
  wrapper: {
    maxWidth: sizes.childScreen,
    margin: '0 auto',
    padding: '24px 24px'
  },
  flex: {
    display: 'flex',
    alignItems: 'center'
  }
}

export default CQIReportComponent
